import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"dot-style\"><a href=\"#dot-style\"></a> Dot Style </h1><div class=\"py-5\"> Use <code>.bullet-vertical</code> to apply vertical style bullet: </div><div class=\"py-5\"><div class=\"rounded border p-10\"><div class=\"d-flex flex-column\"><li class=\"d-flex align-items-center py-2\"><span class=\"bullet bullet-vertical me-5\"></span> Item 1 </li><li class=\"d-flex align-items-center py-2\"><span class=\"bullet bullet-vertical bg-danger me-5\"></span> Item 2 </li><li class=\"d-flex align-items-center py-2\"><span class=\"bullet bullet-vertical bg-success me-5\"></span> Item 3 </li><li class=\"d-flex align-items-center py-2\"><span class=\"bullet bullet-vertical bg-info me-5\"></span> Item 4 </li><li class=\"d-flex align-items-center py-2\"><span class=\"bullet bullet-vertical bg-primary me-5\"></span> Item 5 </li></div></div></div>", 3)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
        <div class="d-flex flex-column">
          <li class="d-flex align-items-center py-2">
            <span class="bullet bullet-vertical me-5"></span> Item 1
          </li>
          <li class="d-flex align-items-center py-2">
            <span class="bullet bullet-vertical bg-danger me-5"></span> Item 2
          </li>
          <li class="d-flex align-items-center py-2">
            <span class="bullet bullet-vertical bg-success me-5"></span> Item 3
          </li>
          <li class="d-flex align-items-center py-2">
            <span class="bullet bullet-vertical bg-info me-5"></span> Item 4
          </li>
          <li class="d-flex align-items-center py-2">
            <span class="bullet bullet-vertical bg-primary me-5"></span> Item 5
          </li>
        </div>
        `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}